var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"external-link",attrs:{"href":_vm.href,"target":"_blank","rel":"noopener"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.text)+" "),_c('IconExternalWindow',{attrs:{"height":_vm.height}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }